import reportsInitialState from './Dashboard/medicalRecords/config/initialState';
import * as commonReducerReports from './Dashboard/medicalRecords/config/reducerGenerator';



const INITIAL_STATE = {
  ...reportsInitialState
};

export default (state = INITIAL_STATE, action) => {
  if (commonReducerReports[action.type]) {
    return commonReducerReports[action.type](state, action);
  } else {
    return state;
  }
};
